<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted () {
    this.$store.dispatch('GET_POKEDEX', this.$store.state.generationId)
  }
}
</script>

<style>
  body,
  #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color: #00bbff;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue